"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeekClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const client_auth_1 = require("@deliverr/client-auth");
const assert_1 = require("@deliverr/commons-utils/lib/assert");
const core_auth_1 = require("@deliverr/core-auth");
class GeekClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = { authEngine: core_auth_1.AuthEngine.COGNITO_INTERNAL }) {
        var _a, _b, _c;
        const clientConfig = Object.assign(Object.assign({}, config), { baseURL: (_a = config.baseURL) !== null && _a !== void 0 ? _a : process.env.GEEK_SERVICE_URL, authEngine: config.authEngine });
        if (clientConfig.authEngine === core_auth_1.AuthEngine.BASIC) {
            clientConfig.basicAuthUser = (_b = config.basicAuthUser) !== null && _b !== void 0 ? _b : process.env.GEEK_BASIC_AUTH_USER;
            clientConfig.basicAuthPassword = (_c = config.basicAuthPassword) !== null && _c !== void 0 ? _c : process.env.GEEK_BASIC_AUTH_PASSWORD;
        }
        if (!clientConfig.baseURL) {
            commons_logs_1.log.warn("baseURL is not configured");
        }
        if (clientConfig.authEngine === core_auth_1.AuthEngine.BASIC &&
            (!clientConfig.basicAuthUser || !clientConfig.basicAuthPassword)) {
            commons_logs_1.log.warn("basicAuthUser and basicAuthPassword are not configured");
        }
        super(clientConfig);
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
            const tokenRefreshFn = tokenHandler.getTokenFn();
            (0, assert_1.assert)(typeof tokenRefreshFn === "function", {
                message: "In order to use the COGNITO_INTERNAL authEngine you must also include an async function that returns a fresh token.",
            });
            this.axios.interceptors.request.use(async (requestConfig) => {
                const tkn = await tokenRefreshFn();
                this.withAccessToken(tkn);
                return requestConfig;
            });
        }
    }
    async releasePackageInformation(cdsku, chuteId) {
        return this.axios
            .request({
            url: "v1/release-package-information",
            method: "POST",
            params: { cdsku, chuteId },
        })
            .then((res) => res.data)
            .catch(this.handleGeekError.bind(this));
    }
    handleGeekError(error) {
        throw this.maybeGetDeliverrError(error) || this.maybeGetNetworkError(error) || this.getUnknownError(error);
    }
}
exports.GeekClient = GeekClient;
exports.default = GeekClient;
//# sourceMappingURL=GeekClient.js.map